{ "compressionlevel":-1,
 "height":11,
 "infinite":false,
 "layers":[
        {
         "data":[1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":11,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":18,
         "x":0,
         "y":0
        }, 
        {
         "id":2,
         "image":"image.png",
         "name":"image",
         "opacity":1,
         "type":"imagelayer",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":3,
         "name":"data:zones",
         "objects":[
                {
                 "height":0,
                 "id":1,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":600,
                         "y":0
                        }, 
                        {
                         "x":600,
                         "y":100
                        }, 
                        {
                         "x":700,
                         "y":100
                        }, 
                        {
                         "x":700,
                         "y":400
                        }, 
                        {
                         "x":600,
                         "y":400
                        }, 
                        {
                         "x":600,
                         "y":500
                        }, 
                        {
                         "x":0,
                         "y":500
                        }, 
                        {
                         "x":0,
                         "y":400
                        }, 
                        {
                         "x":-100,
                         "y":400
                        }, 
                        {
                         "x":-100,
                         "y":300
                        }, 
                        {
                         "x":-200,
                         "y":300
                        }, 
                        {
                         "x":-200,
                         "y":200
                        }, 
                        {
                         "x":-100,
                         "y":200
                        }, 
                        {
                         "x":-100,
                         "y":100
                        }, 
                        {
                         "x":0,
                         "y":100
                        }],
                 "properties":[
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"1"
                        }, 
                        {
                         "name":"zoomout",
                         "type":"string",
                         "value":"1.5"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":700,
                 "y":300
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":4,
 "nextobjectid":2,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.8.6",
 "tileheight":100,
 "tilesets":[
        {
         "firstgid":1,
         "source":"..\/..\/..\/levels\/tileset.json"
        }],
 "tilewidth":100,
 "type":"map",
 "version":"1.8",
 "width":18
}